import { AnalyticsProps } from '../../InternalLibrary/analytics';
import { default as Button, ButtonProps } from 'components/atoms/Button/Button';
import { PropsWithChildren, useCallback } from 'react';
import { Spacer, Text } from 'components';
import { useFormik } from 'formik';
import classNames from 'classnames';
import styles from 'components/atoms/Button/Button.module.scss';
import useEventCollector from '../../hooks/eventCollector/useEventCollector';

export interface ButtonActorProps extends AnalyticsProps {
  formik?: ReturnType<typeof useFormik<any>>;
  buttonProps?: Partial<ButtonProps>;
  width?: string;
  className?: string;
}

export const ButtonActor: React.FC<PropsWithChildren<ButtonActorProps>> = ({
  buttonProps = {},
  analytics,
  formik,
  children,
  width = '100%',
  className,
}) => {
  const { track } = useEventCollector();
  const isSubmit =
    buttonProps.type === 'submit' || buttonProps.name === '_submit';

  const onClick = useCallback(
    (e: any) => {
      buttonProps.name &&
        formik?.status?.errors?.[buttonProps.name] &&
        delete formik.status.errors[buttonProps.name]; // TODO: use formik.setStatus({ errors: {} }); instead! (check for other occurences)
      buttonProps.onClick?.(e);

      if (analytics?.dontTrack) {
        return;
      }
    },
    [
      analytics?.contentOverride,
      analytics?.description,
      analytics?.dontTrack,
      analytics?.dontTrackContent,
      buttonProps,
      formik,
      children,
      track,
    ],
  );
  //TODO: Style it
  return (
    <div
      style={{ width }}
      className={classNames(styles['button-actor-wrapper'], className)}
    >
      <Button {...buttonProps} onClick={onClick}>
        {children}
      </Button>

      {isSubmit && formik?.status?.errors?._submit && (
        <Spacer marginVertical="10px">
          {typeof formik.status.errors._submit[0] === 'string' ? (
            <Text
              kind="p"
              level={3}
              className={styles['validation-text']}
              dangerouslySetInnerHTML={{
                __html: formik.status?.errors?._submit[0],
              }}
            />
          ) : (
            formik.status?.errors?._submit[0]
          )}
        </Spacer>
      )}
    </div>
  );
};
